export class XsdMapper {
    key: string;
    value: string;
}

export const XSD_MAPPER: XsdMapper[] = [

    { key: 'PRTs', value: 'Protesti' },
    { key: 'LPs', value: 'Procedure in Corso' },
    { key: 'PE', value: 'Pregiudizievoli da tribunale' },
    { key: 'LPPE', value: 'Procedure in Corso e Pregiudizievoli da Tribunale' },
    { key: 'LPPE/M', value: 'Messaggio' },
    { key: 'LPPE/C', value: 'Codice' },
    { key: 'PRT', value: 'Protesti' },
    { key: 'PRT/M', value: 'Messaggio' },
    { key: 'PRT/C', value: 'Codice' },
    { key: 'PERER', value: 'Pregiudizievoli da Conservatoria' },
    { key: 'PERER/M', value: 'Messaggio' },
    { key: 'PERER/C', value: 'Codice' },
    { key: 'PE', value: 'Pregiudizievoli da tribunale' },
    { key: 'PRTs/PRT', value: 'Protesti' },
    { key: 'PRTs/PRT/ID', value: 'Anagrafica relativa al Protesto' },

    { key: 'PRTs/PRT/ID/BD', value: 'Data di Nascita' },
    { key: 'PRTs/PRT/ID/BD/TD', value: 'Comune di Nascita' },
    { key: 'PRTs/PRT/ID/BD/PC', value: 'Provincia di Nascita' },
    { key: 'PRTs/PRT/ID/BD/STD', value: 'Stato di Nascita' },
    { key: 'PRTs/PRT/ID/BD/ST', value: 'Codice Stato di Nascita' },
    { key: 'PRTs/PRT/ID/AD', value: 'Indirizzo Residenza' },
    { key: 'PRTs/PRT/ID/AD/TCD', value: 'Tipo di Inidirizzo' },
    { key: 'PRTs/PRT/ID/AD/TC', value: 'Codice Tipo Indirizzo' },
    { key: 'PRTs/PRT/ID/AD/TP', value: 'Toponimo' },
    { key: 'PRTs/PRT/ID/AD/AD', value: 'Indirizzo' },
    { key: 'PRTs/PRT/ID/AD/FA', value: 'Foreign Address' },
    { key: 'PRTs/PRT/ID/AD/N', value: 'Numero Civico' },
    { key: 'PRTs/PRT/ID/AD/TD', value: 'Comune' },
    { key: 'PRTs/PRT/ID/AD/ZC', value: 'CAP' },
    { key: 'PRTs/PRT/ID/AD/PD', value: 'Descrizione Provincia' },
    { key: 'PRTs/PRT/ID/AD/PC', value: 'Codice Provincia' },
    { key: 'PRTs/PRT/ID/AD/VD', value: 'Frazione' },
    { key: 'PRTs/PRT/ID/AD/STD', value: 'Stato' },
    { key: 'PRTs/PRT/ID/AD/ST', value: 'Codice Stato' },
    { key: 'PRTs/PRT/ID/AD/LTCD', value: 'Descrizione Zona della Sede' },
    { key: 'PRTs/PRT/ID/AD/LTC', value: 'Codice Descrizione Zona della Sede' },
    { key: 'PRTs/PRT/ID/AD/FHQTP', value: 'Sede Legale Presso Terzi' },
    { key: 'PRTs/PRT/ID/AD/HQTPD', value: 'Ulteriori Info Indirizzo' },
    { key: 'PRTs/PRT/ID/AD/POBOX', value: 'Casella Postale' },
    { key: 'PRTs/PRT/ID/AD/TWC', value: 'Codice Comune' },
    { key: 'PRTs/PRT/ID/AD/CC', value: 'Codice Regione' },
    { key: 'PRTs/PRT/ID/AD/CD', value: 'Regione' },
    { key: 'PRTs/PRT/ID/ND', value: 'Nominativo' },
    { key: 'PRTs/PRT/ID/TC', value: 'Codice Fiscale' },
    { key: 'PRTs/PRT/ID/ER', value: 'Esito Valutazione anagrafica' },
    { key: 'PRTs/PRT/ID/IDK', value: 'Chiave Anagrafica' },

    { key: 'PRTs/PRT/PRTD', value: 'Dettaglio del protesto' },
    { key: 'PRTs/PRT/PRTD/OI/N', value: 'Altre Informazioni' },
    { key: 'PRTs/PRT/PRTD/TD', value: 'Tipo' },
    { key: 'PRTs/PRT/PRTD/TDD', value: 'Codice Tipo' },
    { key: 'PRTs/PRT/PRTD/A', value: 'Importo' },
    { key: 'PRTs/PRT/PRTD/C', value: 'Valuta' },
    { key: 'PRTs/PRT/PRTD/EXPD', value: 'Data Scadenza' },
    { key: 'PRTs/PRT/PRTD/STSD', value: 'Stato' },
    { key: 'PRTs/PRT/PRTD/STS', value: 'Codcie Stato' },
    { key: 'PRTs/PRT/PRTD/RD', value: 'Data di Levata' },
    { key: 'PRTs/PRT/PRTD/REGD', value: 'Data di Registrazione' },
    { key: 'PRTs/PRT/PRTD/RTD', value: 'Comune di Levata' },
    { key: 'PRTs/PRT/PRTD/RPC', value: 'Codice Provincia di Levata' },
    { key: 'PRTs/PRT/PRTD/CC', value: 'Camera di Commercio' },
    { key: 'PRTs/PRT/PRTD/NCD', value: 'Annotamento' },
    { key: 'PRTs/PRT/PRTD/NC', value: 'Codice Annotamento' },
    { key: 'PRTs/PRT/PRTD/RNPD', value: 'Causale Mancato Pagamento' },
    { key: 'PRTs/PRT/PRTD/RNP', value: 'Codice Causale Mancato Pagamento' },
    { key: 'PRTs/PRT/PRTD/DEE', value: 'Data emissione effetti' },

    { key: 'LPs/LP/ID', value: 'Anagrafica' },
    { key: 'LPs/LP/ID/LPT/TD', value: 'Tipo di Procedura' },
    { key: 'LPs/LP/ID/LPT/TC', value: 'Codice Tipo' },
    { key: 'LPs/LP/ID/CPs', value: 'Comunicazione Curatore' },
    { key: 'LPs/LP/ID/CPs/EH', value: 'Estremi Udienza' },
    { key: 'LPs/LP/ID/CPs/DH', value: 'Data Udienza' },
    { key: 'LPs/LP/ID/CPs/DE', value: 'Data Termine' },
    { key: 'LPs/LP/ID/CPs/P', value: 'Luogo' },
    { key: 'LPs/LP/ID/CPs/C', value: 'Tribunale' },
    { key: 'LPs/LP/ID/CPs/NP', value: 'Numero Provvedimento' },
    { key: 'LPs/LP/ID/CPs/DP', value: 'Data Provvedimento' },
    { key: 'LPs/LP/ID/CPs/NJ', value: 'Nome Giudice' },
    { key: 'LPs/LP/ID/CPs/SJ', value: 'Cognome Giudice' },
    { key: 'LPs/LP/ID/ILP', value: 'Informazioni Procedurali Concorsuali' },
    { key: 'LPs/LP/ID/ILP/IC', value: 'Informazioni Curatore' },
    { key: 'LPs/LP/ID/ILP/AD', value: 'Accordi e Debiti' },
    { key: 'LPs/LP/ID/ILP/RC', value: 'Rapporto Curatore' },
    { key: 'LPs/LP/ID/ILP/AR', value: 'Appelli e Reclami' },
    { key: 'LPs/LP/ID/ILP/PA', value: 'Proposta Concordato' },
    { key: 'LPs/LP/ID/ILP/TO', value: 'Esercizio Provvisorio' },
    { key: 'LPs/LP/ID/ILP/CTO', value: 'Continuazione Esercizio Provvisorio' },
    { key: 'LPs/LP/ID/ILP/CeTO', value: 'Cessazione Esercizio Provvisorio' },
    { key: 'LPs/LP/ID/ILP/IA', value: 'Esecuzione Concordato' },
    { key: 'LPs/LP/ID/ILP/RP', value: 'Annotazioni procedure' },
    { key: 'LPs/LP/ID/ND', value: 'Nominativo' },
    { key: 'LPs/LP/ID/TC', value: 'Codice Fiscale' },
    { key: 'LPs/LP/ID/RC', value: 'Numero REA' },
    { key: 'LPs/LP/ID/PCCIAA', value: 'Codice Provincia CCIAA' },
    
    { key: 'PERER/CJD', value: 'Atto' },
    { key: 'PERER/CJD/REGD', value: 'Data Registrazione Atto' },
    { key: 'PERER/CJD/CO', value: 'Codice Ufficio' },
    { key: 'PERER/CJD/ON', value: 'Ufficio' },
    { key: 'PERER/CJD/OP', value: 'Provincia Ufficio' },
    { key: 'PERER/CJD/GN', value: 'Numero Generale' },
    { key: 'PERER/CJD/DN', value: 'Numero Particolare' },
    { key: 'PERER/CJD/DC', value: 'Tipo Atto' },
    { key: 'PERER/CJD/DCD', value: 'Codice Tipo Atto' },
    { key: 'PERER/CJD/DCCD', value: 'Categoria Documento' },
    { key: 'PERER/CJD/DCC', value: 'Codice Categoria Documento' },
    { key: 'PERER/CJD/N', value: 'Note' },
    { key: 'PERER/CJD/CD', value: 'Data Chiusura' },
    { key: 'PERER/CJD/RD', value: 'Data Revoca' },
    { key: 'PERER/CJD/C', value: 'Valuta' },

    { key: 'PERER/ADE', value: 'Annotamenti' },
    { key: 'PERER/ADE/ACD', value: 'Codice Annotamento' },
    { key: 'PERER/ADE/AC', value: 'Data Annotamento' },
    { key: 'PERER/ADE/GN', value: 'Numero Generale' },
    { key: 'PERER/ADE/DN', value: 'Numero Particolare' },
    { key: 'PERER/ADE/DAS', value: 'Specie Annotamento' },
    { key: 'PERER/ADE/DSCFORNITORE', value: 'Annotazione da fornitore' },

    { key: 'PERER/DA', value: 'Anagrafica Contro' },
    { key: 'PERER/DA/P/N', value: 'Nome' },
    { key: 'PERER/DA/P/S', value: 'Cognome' },
    { key: 'PERER/DA/P/TC', value: 'Codice Fiscale' },
    { key: 'PERER/DA/P/BD/D', value: 'Data di Nascita' },
    { key: 'PERER/DA/P/BD/TD', value: 'Comune di Nascita' },
    { key: 'PERER/DA/P/BD/PC', value: 'Provincia di Nascita' },
    { key: 'PERER/DA/P/BD/STD', value: 'Stato di Nascita' },
    { key: 'PERER/DA/P/BD/ST', value: 'Codice Stato di Nascita' },
    
    { key: 'PERER/DF', value: 'Anagrafica a favore' },
    { key: 'PERER/DF/C/ND', value: 'Denominazione' },
    { key: 'PERER/DF/C/TC', value: 'Codice Fiscale' },
    { key: 'PERER/DF/C/AD/TD', value: 'Comune di Nascita' },
    { key: 'PERER/DF/C/AD/PC', value: 'Codice Provincia' },
    { key: 'PERER/DF/C/AD/PD', value: 'Descrizione Provincia' },

    { key: 'PERER/A', value: 'Beni' },
    { key: 'PERER/A/T', value: 'Comune' },
    { key: 'PERER/A/P', value: 'Provincia' },

    { key: 'PERER/DD', value: 'Dettagli atto Catasto' },
    { key: 'PERER/DD/TA', value: 'Importo Totale' },
    { key: 'PERER/DD/EA', value: 'Importo Spese' },
    { key: 'PERER/DD/FA', value: 'Importo Finanziato' },
    { key: 'PERER/DD/C', value: 'Valuta' },
    { key: 'PERER/DD/CD', value: 'Descrizione Valuta' },

    { key: 'PE/CJD', value: 'Dettagli Atto' },
    { key: 'PE/CJD/REGD', value: 'Data Registrazione Atto' },
    { key: 'PE/CJD/ON', value: 'Ufficio' },
    { key: 'PE/CJD/OP', value: 'Provincia Ufficio' },
    { key: 'PE/CJD/GN', value: 'Numero Generale' },
    { key: 'PE/CJD/DN', value: 'Numero Particolare' },
    { key: 'PE/CJD/DCD', value: 'Tipo Atto' },
    { key: 'PE/CJD/DC', value: 'Codice Tipo Atto' },
    { key: 'PE/CJD/DCCD', value: 'Categoria Documento' },
    { key: 'PE/CJD/DCC', value: 'Codice Categoria' },

    { key: 'PE/DA', value: 'Anagrafica Contro' },
    { key: 'PE/DA/C', value: 'Impresa' },
    { key: 'PE/DA/C/ND', value: 'Denominazione' },
    { key: 'PE/DA/C/LFCD', value: 'Natura Giuridica' },
    { key: 'PE/DA/C/LFC', value: 'Codice Natura Giuridica' },
    { key: 'PE/DA/P', value: 'Persona Fisica' },
    { key: 'PE/DA/P/N', value: 'Nome' },
    { key: 'PE/DA/P/S', value: 'Cognome' },
    { key: 'PE/DA/P/TC', value: 'Codice Fiscale' },
    { key: 'PE/DA/P/BD', value: 'Data Di Nascita' },
    { key: 'PE/DA/P/BD/D', value: 'Data Di Nascita' },
    { key: 'PE/DA/P/BD/TD', value: 'Comune di Nascita' },
    { key: 'PE/DA/P/BD/PC', value: 'Provincia di Nascita' },


    { key: 'PE/CJCD', value: 'Atto da tribunale' },
    { key: 'PE/CJCD/HD', value: 'Data Udienza' },
    { key: 'PE/CJCD/T', value: 'Curatore' },
    { key: 'PE/CJCD/N', value: 'Note' },
    { key: 'PE/CJCD/AD', value: 'Indirizzo Curatore' },
    { key: 'PE/CJCD/AD/AD', value: 'Indirizzo' },
    { key: 'PE/CJCD/AD/TD', value: 'Comune' },
    { key: 'PE/CJCD/AD/PC', value: 'Codice Provincia' },
    { key: 'PE/CJCD/AD/PD', value: 'Descrizione Provincia' },

    
]